import { memo } from 'react'

import notifyBanner from 'assets/no-qbx-banner.jpg'
import Notification from './Notification'

const NoQBXNotification = ({ ...restProps }) => {
  return (
    <Notification
      title='notification.no-qbx'
      desc='notification.no-qbx-desc'
      banner={notifyBanner}
      noSubmit
      {...restProps}
    />
  )
}

export default memo(NoQBXNotification)
